import type React from 'react';
import { createContext, useContext } from 'react';
import { type Config, getConfig } from './configStore';

interface ConfigProviderProps {
  children: React.ReactNode;
}

const ConfigContext = createContext<Config | undefined>(undefined);

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }

  return context;
};

export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  const config = getConfig();
  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};
